import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { Account } from '@smmof/entity';
import { ApiServerService } from '../../shared/services/api-server.service';
import { AccountActions } from '../../store/actions/account.actions';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _user: ReplaySubject<Account> = new ReplaySubject<Account>(1);

  /**
   * Constructor
   */
  constructor(
    private _httpClient: HttpClient,
    private _apiService: ApiServerService,
    private _store: Store
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Setter & getter for user
   *
   * @param value
   */
  set user(value: Account) {
    // Store the value
    this._user.next(value);
  }

  get user$(): Observable<Account> {
    return this._user.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get the current logged in user data
   */
  get(): Observable<Account> {
    return this._apiService.GET<Account>('account').pipe(
      tap((account) => {
        this._store.dispatch(AccountActions.setAccountData({
          account,
        }));
        // @ts-ignore
        this._user.next({
          ...account,
          money: Number(account.money)
        });
      })
    );
  }

  /**
   * Update the user
   *
   * @param user
   */
  update(user: Account): Observable<any> {
    return this._httpClient.patch<Account>('api/common/user', { user }).pipe(
      map((response) => {
        this._user.next(response);
      })
    );
  }
}
